module.exports = __webpack_public_path__ + "img/24_27.870a6145.png";